import MaskField from '@components/v2/form/MaskField/MaskField';
import Select from '@components/v2/form/Select/Select';
import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Button from '@components/v2/ui/Button/Button';
import StatusAdornment from '../../components/StatusAdornment';
import LangEnum from '../../lang/LangEnum';
import { getWhatsappLink, whatsapp } from '../../utils/constants';
import { cnpjRegex } from '../../utils/regexes';
import { StoreSignUpTestIds } from '../../utils/testIds/storeSignUp.testIds';
import TermsAgreement from '../login/components/LoginPanel/components/TermsAgreement/TermsAgreement';
import { useTranslation } from '../translation/TranslationContext';
import useLocationAndCnpjStep from './hooks/useLocationAndCnpjStep';
import useLocationAndCnpjStepStyles from './locationAndCnpjStep.styles';

const LocationAndCnpjStep = () => {
  const {
    location,
    cnpj,
    isBr,
    loginPath,
    countryOptions,
    handleCnpjChange,
    handleCountryChange,
    handleContinue,
    errorMessage,
    isCnpjAlreadyRegistered,
    hasFieldError,
    cnpjHelperTextKey,
    cnpjAdornmentStatus,
  } = useLocationAndCnpjStep();
  const { translate } = useTranslation();
  const { classes } = useLocationAndCnpjStepStyles();

  const whatsappLink = getWhatsappLink({
    phone: whatsapp.phone,
    text: translate(whatsapp.helpMessage),
  });

  return (
    <AuthPanel below={<TermsAgreement />}>
      <div className={classes.fields}>
        <Select
          label={translate(LangEnum.LOCATION_STEP_TITLE)}
          value={location?.code ?? ''}
          onChange={(event) => handleCountryChange(String(event.target.value))}
          options={countryOptions}
          testId={StoreSignUpTestIds.COUNTRY_SELECT}
          fullWidth
        />
        {isBr && (
          <MaskField
            mask={cnpjRegex}
            value={cnpj}
            onChange={(event) => handleCnpjChange(event.currentTarget.value)}
            label={translate(LangEnum.CNPJ_STEP_TITLE)}
            error={hasFieldError}
            helperText={cnpjHelperTextKey ? translate(cnpjHelperTextKey) : undefined}
            slotProps={{
              htmlInput: { 'test-id': StoreSignUpTestIds.CNPJ_FIELD },
              input: {
                endAdornment: (
                  <StatusAdornment status={cnpjAdornmentStatus} errorMessage={errorMessage} />
                ),
              },
            }}
            fullWidth
          />
        )}
      </div>
      <div className={classes.actions}>
        {isCnpjAlreadyRegistered ? (
          <>
            <Button
              testId={StoreSignUpTestIds.BACK_TO_LOGIN_BUTTON}
              variant="contained"
              size="large"
              color="primary"
              fullWidth
              to={loginPath}
            >
              {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
            </Button>
            <Button
              testId={StoreSignUpTestIds.HELP_BUTTON}
              variant="text"
              color="secondary"
              size="large"
              fullWidth
              href={whatsappLink}
            >
              {translate(LangEnum.REGISTER_LOCATION_CNPJ_STEP_CNPJ_EXISTS_HELP_BUTTON)}
            </Button>
          </>
        ) : (
          <>
            <Button
              testId={StoreSignUpTestIds.CONTINUE_BUTTON}
              variant="contained"
              size="large"
              color="primary"
              fullWidth
              onClick={handleContinue}
            >
              {translate(LangEnum.GLOBAL_CONTINUE)}
            </Button>
            <Button
              testId={StoreSignUpTestIds.GO_TO_LOGIN_LINK}
              variant="text"
              color="secondary"
              size="large"
              fullWidth
              to={loginPath}
            >
              {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
            </Button>
          </>
        )}
      </div>
    </AuthPanel>
  );
};

export default LocationAndCnpjStep;
